<script>
export default {
  functional: true,

  render(h, { data, slots }) {
    return (
      <div class={[data.class, data.staticClass, `v-button-group`]}>
        {slots().default}
      </div>
    )
  }
}
</script>

<style lang="scss">
.v-button-group {
  display: flex;
  .v-button {
    flex-grow: 1;
  }

  .v-button:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .v-button:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
